import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./input.module.scss";
import s from "./input.module.scss";
import { ComponentWrapperHOC } from "../../components/WrapperHoc";
import { commonFields } from "../../sharedTypes/components";
import { DateIcon } from "../../assets/svgs/DateIcon";
import styled from "styled-components";
import { formatDateToYYYYMMDD } from "../../utils/index";
import { useState } from "react";

interface dateProps extends commonFields {
  label: string;
  value?: Date;
  fullwidth?: string;
  width?: string;
  required?: boolean;
  name?: string;
  changeFn?: (name: string, date: Date | string) => void;
  className?: string;
  maxDate?: Date;
  showYearDropdown?: boolean;
}

export const DateField = ({
  name,
  changeFn,
  fullwidth,
  width = "auto",
  label,
  required,
  labelStyle,
  placeholder,
  className,
  value,
  maxDate,
  ...rest
}: dateProps) => {
  const wrapperWidth = fullwidth ? "100%" : width;

  const [_date, setDate] = useState<Date>();
  const handleChange = (date: Date) => {
    changeFn && changeFn(name || "", formatDateToYYYYMMDD(date));
    setDate(date);
  };

  // console.log(typeof value);
  return (
    <ComponentWrapperHOC
      wrap={!!label}
      wrapper={(children) => (
        <div style={{ width: wrapperWidth, ...labelStyle }} className={s.label}>
          <span>
            {label}
            {required ? <sup className={s.required}>*</sup> : null}
          </span>
          {children}
        </div>
      )}
    >
      <CustomDatePickerWrapper>
        <DatePicker
          // selected={date}
          selected={value?.toString() === "Invalid Date" ? null : value}
          onChange={handleChange}
          // dateFormat="yyyy-dd-mm"
          placeholderText={placeholder}
          // dateFormat="yyyy-dd-mm"
          className={`${[s["date-input"], className && s[className]].join(
            " "
          )} !tw-w-full tw-h-full`}
          maxDate={maxDate}
          yearDropdownItemNumber={50}
          scrollableYearDropdown
          withPortal={true}
          wrapperClassName="!tw-w-full"
          {...rest}
        />

        <div className="tw-absolute tw-top-0 tw-bottom-0 tw-my-auto tw-right-[10px]">
          <DateIcon />
        </div>
      </CustomDatePickerWrapper>
    </ComponentWrapperHOC>
  );
};

const CustomDatePickerWrapper = styled.div`
  height: 2.8125rem;
  width: 100% !important;
  position: relative;
  font-size: 0.9375rem;
  display: flex;
  flex-direction: row;

  div:has(> .react-datepicker__input-container) {
    width: 100% !important;
  }

  .react-datepicker-wrapper {
    width: 100%;

    .react-datepicker__input-container {
      width: 100%;
    }
  }
`;
